import React, { useState } from "react";
import { ArrowRight, Twitter, Linkedin, Youtube } from "lucide-react";
import Logo from "../assets/Nuplay.svg"

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e: any) => {
    e.preventDefault();
    console.log("Newsletter signup:", email);
    // Handle newsletter signup logic here
  };

  return (
    <footer className="w-[100vw] md:px-[120px] border-l-[2px] border-white  bg-black text-white py-16 px-6 mx-[-25px] overflow-x-hidden">
      <div className="mx-auto">
        {/* Top Section */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
          {/* Left - Brand and Certifications + Newsletter stacked vertically */}
          <div className="lg:col-span-3">
            <div className="mb-4 text-left">
              <h2 className="text-4xl font-bold mb-2">
                NUPLA<span className="text-blue-500">Y</span>
              </h2>
              <p className="text-white text-2xl">Future of Enterprise AI</p>
            </div>
            {/* Certification Badges */}
            <div className="flex space-x-4 mt-8">
              <div className="w-16 h-16 border border-gray-600 rounded-full flex items-center justify-center">
                <div className="text-xs font-bold text-center">
                  <div className="text-white">ISO</div>
                </div>
              </div>
              <div className="w-16 h-16 border border-gray-600 rounded-full flex items-center justify-center">
                <div className="w-6 h-6">
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="text-white"
                  >
                    <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 5.5C14.8 4.1 13.6 3 12.1 3C10.6 3 9.4 4.1 9.2 5.5L3 7V9L9 7.5V12C7.3 12.3 6 13.7 6 15.5C6 17.4 7.6 19 9.5 19S13 17.4 13 15.5C13 13.7 11.7 12.3 10 12V7.5L15 9ZM9.5 17C8.7 17 8 16.3 8 15.5S8.7 14 9.5 14S11 14.7 11 15.5S10.3 17 9.5 17Z" />
                  </svg>
                </div>
              </div>
              <div className="w-16 h-16 border border-gray-600 rounded-full flex items-center justify-center">
                <div className="w-6 h-6">
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="text-white"
                  >
                    <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10.5V11.5C15.4,11.5 16,12.1 16,12.7V16.7C16,17.4 15.4,18 14.8,18H9.2C8.6,18 8,17.4 8,16.8V12.8C8,12.1 8.6,11.5 9.2,11.5V10.5C9.2,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.5,8.7 10.5,9.5V11.5H13.5V9.5C13.5,8.7 12.8,8.2 12,8.2Z" />
                  </svg>
                </div>
              </div>
              <div className="w-16 h-16 border border-gray-600 rounded-full flex items-center justify-center">
                <div className="text-xs font-bold text-center text-white">
                  <div>SOC2</div>
                  <div className="text-[8px]">TYPE 2</div>
                </div>
              </div>
            </div>
            {/* Newsletter Signup - stacked below badges */}
            <div className="mt-8">
              <h3 className="text-3xl text-left mb-6 leading-relaxed">
                Subscribe to our Newsletter
              </h3>
              <div className="relative w-full">
                <input
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-transparent border-b-2 border-gray-600 py-8 px-0 text-white placeholder-gray-400 focus:border-blue-500 focus:outline-none pr-32"
                />
                <button
                  onClick={handleSubmit}
                  className="absolute right-0 top-1/2 -translate-y-1/2 bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-full flex items-center justify-center transition-colors"
                >
                  <ArrowRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>

          {/* Right - Company, Solutions, Industry */}
          <div className="lg:col-span-9 grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Company */}
            <div>
  <h4 className="text-blue-500 md:ml-[80px] font-semibold mb-4 uppercase tracking-wide text-left">
    Company
  </h4>
  <ul className="space-y-3 text-left md:ml-[80px]">
    <li>
      <a
        href="#"
        className="text-white hover:text-white transition-colors"
      >
        About Us
      </a>
    </li>
    <li>
      <a
        href="#"
        className="text-white hover:text-white transition-colors"
      >
        Careers
      </a>
    </li>
    <li>
      <a
        href="#"
        className="text-white hover:text-white transition-colors"
      >
        Contact Us
      </a>
    </li>
  </ul>
              {/* Resources menu placed below Company menu */}
              <div className="mt-[90px] md:ml-[80px]">
                <h4 className="text-blue-500 font-semibold mb-4 uppercase tracking-wide text-left">
                  RESOURCES
                </h4>
                <ul className="space-y-3 text-left">
                  <li>
                    <a
                      href="#"
                      className="text-white hover:text-white transition-colors"
                    >
                      Success Stories
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="text-white hover:text-white transition-colors"
                    >
                      Use Cases
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="text-white hover:text-white transition-colors"
                    >
                      Blogs
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="text-white hover:text-white transition-colors"
                    >
                      Webinars
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="text-white hover:text-white transition-colors"
                    >
                      AI Explained
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Solutions */}
            <div>
             <h4 className="text-blue-500 md:ml-[75px] font-semibold mb-4 uppercase tracking-wide text-left">
    Solutions
  </h4>
              <ul className="space-y-3 text-left md:ml-[75px]">
                <li>
                  <a
                    href="#"
                    className="text-white hover:text-white transition-colors"
                  >
                    Sales
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-white hover:text-white transition-colors"
                  >
                    Support
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-white hover:text-white transition-colors"
                  >
                    Document Processing
                  </a>
                </li>
              </ul>
              {/* Legal menu placed below Solutions menu */}
              <div className="mt-[90px] md:ml-[75px]">
                <h4 className="text-blue-500 font-semibold mb-4 uppercase tracking-wide text-left">
                  LEGAL
                </h4>
                <ul className="space-y-3 text-left">
                  <li>
                    <a
                      href="#"
                      className="text-white hover:text-white transition-colors"
                    >
                      Terms
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="text-white hover:text-white transition-colors"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="text-white hover:text-white transition-colors"
                    >
                      DPA
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="text-white hover:text-white transition-colors"
                    >
                      BAA
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Industry */}
            <div>
             <h4 className="text-blue-500 md:ml-[80px] font-semibold mb-4 uppercase tracking-wide text-left">
    Industry
  </h4>
              <ul className="space-y-3 text-left md:ml-[80px]">
                <li>
                  <a
                    href="#"
                    className="text-white hover:text-white transition-colors"
                  >
                    Retail
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-white hover:text-white transition-colors"
                  >
                    Insurance
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-white hover:text-white transition-colors"
                  >
                    Home Services
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-white hover:text-white transition-colors"
                  >
                    Health and Fitness
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-white hover:text-white transition-colors"
                  >
                    Education
                  </a>
                </li>
              </ul>
              {/* Copyright and Social Media below Industry */}
              <div className="mt-16 md:ml-[80px]">
                <div className="flex space-x-4 mb-4">
                  <a
                    href="#"
                    className="text-white hover:text-blue-500 transition-colors"
                  >
                    <Twitter className="w-7 h-7" />
                  </a>
                  <a
                    href="#"
                    className="text-white hover:text-blue-500 transition-colors"
                  >
                    <Linkedin className="w-7 h-7" />
                  </a>
                  <a
                    href="#"
                    className="text-white hover:text-blue-500 transition-colors"
                  >
                    <Youtube className="w-7 h-7" />
                  </a>
                </div>
                <div className="text-white text-lg ml-[-60px]">
                  Nuplay.ai © 2025
                </div>
              </div>
                  
            </div>
          </div>
          
          
        </div>
      </div>
      <img src={Logo} alt="Nuplay Logo" className="w-auto" />
    </footer>
  );
};

export default Footer;
